module.exports = __webpack_public_path__ + "static/img/cocina.0b7a093a.jpg";